import { useCheckFeature } from "@/composables/useCheckFeature";
import { storeToRefs } from "pinia";
import { useAuth } from "@/stores/AuthStore";

export const lifeBenefitsGuard = async (to, from, next) => {
    const { organization } = storeToRefs(useAuth());
    const { loadMemberFeatures, canAccessLifePolicies } = useCheckFeature();

    await loadMemberFeatures(organization.value.slug);

    if (canAccessLifePolicies.value) {
        return next();
    }

    return next("");
};
